<template>
  <layout-header></layout-header>
  <layout-sidebar></layout-sidebar>

  <div class="page-wrapper">
    <div class="content">
      <div
        class="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3"
      >
        <breadcrumb :title="title" :text="text" :text1="text1" />

        <div
          class="d-flex my-xl-auto right-content align-items-center flex-wrap dq-page-actions"
        >
          <div class="me-2 mb-2">
            <div
              class="d-flex align-items-center border bg-white rounded p-1 me-2"
            >
              <router-link
                to="/projects/projects-list"
                class="btn btn-icon btn-sm active bg-primary text-white me-1"
              >
                <i class="ti ti-list-tree"></i>
              </router-link>
              <router-link
                to="/projects/projects-grid"
                class="btn btn-icon btn-sm"
              >
                <i class="ti ti-layout-grid"></i>
              </router-link>
            </div>
          </div>

          <div class="me-3 mb-2">
            <input
              v-model="store.filters.q"
              @input="debouncedReload()"
              type="text"
              class="form-control"
              placeholder="Search projects..."
            />
          </div>

          <div class="dropdown me-2 mb-2">
            <a
              href="javascript:void(0);"
              class="dropdown-toggle btn btn-white d-inline-flex align-items-center"
              data-bs-toggle="dropdown"
            >
              Select Priority
            </a>
            <ul class="dropdown-menu dropdown-menu-end p-3">
              <li>
                <a class="dropdown-item rounded-1" @click="setPriority('')"
                  >All</a
                >
              </li>
              <li>
                <a class="dropdown-item rounded-1" @click="setPriority('High')"
                  >High</a
                >
              </li>
              <li>
                <a
                  class="dropdown-item rounded-1"
                  @click="setPriority('Medium')"
                  >Medium</a
                >
              </li>
              <li>
                <a class="dropdown-item rounded-1" @click="setPriority('Low')"
                  >Low</a
                >
              </li>
            </ul>
          </div>

          <div class="dropdown me-2 mb-2">
            <a
              href="javascript:void(0);"
              class="dropdown-toggle btn btn-white d-inline-flex align-items-center"
              data-bs-toggle="dropdown"
            >
              Select Status
            </a>
            <ul class="dropdown-menu dropdown-menu-end p-3">
              <li>
                <a class="dropdown-item rounded-1" @click="setStatus('')"
                  >All</a
                >
              </li>
              <li>
                <a class="dropdown-item rounded-1" @click="setStatus('Active')"
                  >Active</a
                >
              </li>
              <li>
                <a
                  class="dropdown-item rounded-1"
                  @click="setStatus('Inactive')"
                  >Inactive</a
                >
              </li>
            </ul>
          </div>

          <div class="dropdown me-2 mb-2">
            <a
              href="javascript:void(0);"
              class="dropdown-toggle btn btn-white d-inline-flex align-items-center"
              data-bs-toggle="dropdown"
            >
              Sort
            </a>
            <ul class="dropdown-menu dropdown-menu-end p-3">
              <li>
                <a class="dropdown-item rounded-1" @click="setSort('recent')"
                  >Recently Added</a
                >
              </li>
              <li>
                <a class="dropdown-item rounded-1" @click="setSort('asc')"
                  >Ascending</a
                >
              </li>
              <li>
                <a class="dropdown-item rounded-1" @click="setSort('desc')"
                  >Descending</a
                >
              </li>
            </ul>
          </div>

          <div class="mb-2">
            <a
              href="javascript:void(0);"
              data-bs-toggle="modal"
              data-bs-target="#add_project"
              class="btn btn-primary d-flex align-items-center"
              @click="openCreate"
              v-can="'Project.Create'"
            >
              <i class="ti ti-circle-plus me-2"></i>
              Add Project
            </a>
          </div>

          <div class="ms-2 head-icons">
            <a
              href="javascript:void(0);"
              id="collapse-header"
              @click="toggleHeader"
            >
              <i class="ti ti-chevrons-up"></i>
            </a>
          </div>
        </div>
      </div>

      <div class="card">
        <div
          class="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3"
        >
          <h5>Project List</h5>
        </div>
        <div class="card-body p-0">
          <div class="custom-datatable-filter table-responsive">
            <projects-table
              @edit="onEdit"
              @delete="onDelete"
              @view="onView"
            ></projects-table>
          </div>
        </div>
      </div>
    </div>

    <div
      class="footer d-sm-flex align-items-center justify-content-between border-top bg-white p-3"
    >
      <p class="mb-0">2014 - {{ new Date().getFullYear() }} &copy; DoneQuick HR & Payroll</p>
      <p>
        Powered by
        <a href="javascript:void(0);" class="text-primary"
          >DoneQuick Technological World</a
        >
      </p>
    </div>
  </div>

  <project-grid-modal ref="projectModal"></project-grid-modal>
  <project-details-modal ref="detailsModal"></project-details-modal>
</template>

<script setup>
import { ref, onMounted, computed } from "vue";
import { useProjectStore } from "@/stores/projectStore";
import ProjectsTable from "./projects-table.vue";
import ProjectGridModal from "@/components/modal/project-grid-modal.vue";
import ProjectDetailsModal from "@/components/modal/project-details-modal.vue";
import { useAuthStore } from "@/stores/authStore";

// NEW:
import { Modal } from "bootstrap";

const auth = useAuthStore();
const isEmployee = computed(() => auth.roles?.includes("Employee"));

const title = "Project List";
const text = "Projects";
const text1 = "Project List";

const projectModal = ref(null);
const detailsModal = ref(null);
const store = useProjectStore();

function toggleHeader() {
  document.getElementById("collapse-header")?.classList.toggle("active");
  document.body.classList.toggle("header-collapse");
}

function setPriority(v) {
  store.filters.priority = v;
  store.list();
}
function setStatus(v) {
  store.filters.status = v;
  store.list();
}
function setSort(v) {
  store.filters.sort = v;
  store.list();
}

let t;
function debouncedReload() {
  clearTimeout(t);
  t = setTimeout(() => store.list(), 250);
}

function openCreate() {
  projectModal.value?.openForCreate();
}

function exportAs(format) {
  store.downloadReport(format);
}

async function onEdit(rec) {
  // Show the modal immediately for a snappy feel
  const el = document.getElementById("add_project");
  if (el) new Modal(el, { backdrop: "static", keyboard: false }).show();

  // Load data into the modal
  try {
    await projectModal.value?.openForEdit(rec.id);
  } catch (e) {
    // If fetch fails, hide the modal again
    const inst = Modal.getInstance(el);
    inst?.hide();
  }
}

function onView(rec) {
  detailsModal.value?.open(rec.id);
}

// async function onDelete(rec) {
//   await store.remove(rec.id);
//   store.list();
// }

async function onDelete(rec) {
  // 1) Tell the modal which record we plan to delete
  projectModal.value?.openForDelete(rec.id);

  // 2) Show the delete confirmation modal
  const el = document.getElementById("delete_project");
  if (el) {
    new Modal(el, { backdrop: "static", keyboard: false }).show();
  }
}

onMounted(() => {
  if (isEmployee.value) store.filters.scope = "me";
  store.ensureList();
});
</script>

<style scoped>
@media (max-width: 767.98px) {
  .custom-datatable-filter.table-responsive {
    margin-left: -1rem;
    margin-right: -1rem;
    padding-left: 1rem;
    padding-right: 1rem;
    width: calc(100% + 2rem);
  }
}
</style>


